import moment from "moment";

export const FJB_SEARCH_OPTIONS = [
  {
    label: "Nama Customer",
    value: "namaPembawa",
  },
  {
    label: "No Polisi",
    value: "nomorPolisi",
  },
];

export const INITIAL_SEARCH_DATA_DGI = {
  startPeriod: moment().format("DD-MM-YYYY"),
  endPeriod: moment().format("DD-MM-YYYY"),
};

export const INITIAL_SEARCH_DATA_NOS = {
  startTanggalFJB: moment().format("DD-MM-yyyy"),
  endTanggalFJB: moment().format("DD-MM-yyyy"),
};

export const INITIAL_PAGINATION = {
  totalData: 0,
  page: 1,
  limit: 5,
};

export const ALERT_INFO_CONFIRMATION_TYPE = {
  INFO: "INFO",
  CLEAR_INPUT: "CLEAR_INPUT",
  SUBMIT: "SUBMIT",
};

export const INITIAL_FORM_MANDATORY = { value: null, mandatory: true };

export const INITIAL_FORM_NON_MANDATORY = { value: null };

export const INITIAL_DATE = moment().format("DD-MM-YYYY");

export const FAKTUR_JUAL_BENGKEL_KATEGORI = [
  {
    label: "Work Order",
    value: "WORK_ORDER",
  },
  {
    label: "Direct Sales",
    value: "DIRECT_SALES",
  },
];

export const TIPE_FJB_OPTIONS = [
  { label: "REGULER", value: "REGULER" },
  { label: "C1", value: "C1" },
  { label: "C2", value: "C2" },
  { label: "STOCK OPNAME", value: "STOCK_OPNAME" },
  { label: "JOB RETURN", value: "JOB_RETURN" },
];

export const ENUM_TIPE_FJB = {
  REGULER: "REGULER",
  C1: "C1",
  C2: "C2",
  STOCK_OPNAME: "STOCK_OPNAME",
  JOB_RETURN: "JOB_RETURN",
};

export const PROSPEK_SOURCE_OPTIONS = [
  { label: "NEW", value: "NEW" },
  { label: "RO H1", value: "RO_H1" },
  { label: "RO H23", value: "RO_H23" },
  { label: "XS H21", value: "XS_H21" },
  { label: "XS H21P", value: "XS_H21P" },
];

export const TIPE_PROMO_OPTIONS = [
  { label: "PROMO", value: "PROMO" },
  { label: "VOUCHER", value: "VOUCHER" },
];

export const TIPE_PEMBAYARAN_OPTIONS = [
  { label: "TUNAI", value: "TUNAI" },
  { label: "NON TUNAI", value: "NON_TUNAI" },
];

export const TIPE_PEMBAYARAN_NON_TUNAI_OPTIONS = [
  { label: "TRANSFER", value: "TRANSFER" },
  { label: "QRIS", value: "QRIS" },
];

export const JENIS_PIT_OPTIONS = [
  { label: "REGULAR", value: "REGULAR" },
  { label: "FAST TRACK", value: "FAST_TRACK" },
  { label: "BOOKING", value: "BOOKING" },
  { label: "PIT EXPRESS", value: "PIT_EXPRESS" },
];

export const STATUS_FJB_OPTIONS = [
  { label: "Draft", value: "DRAFT" },
  { label: "Waiting for Approval", value: "WAITING_FOR_APPROVAL" },
  { label: "Submitted", value: "SUBMITTED" },
  { label: "Completed", value: "COMPLETED" },
];

export const INITIAL_SAVED_ROW = {
  isSavedDiscount: true,
  isSavedPrice: true,
  isSavedCurrency: true,
}

export const INITIAL_DATA_TABLE_JASA_JOB = {
  kodeJasa: null,
  namaJasa: null,
  serviceCategory: null,
  hargaSatuanSistem: 0,
  hargaDiberikan: 0,
  diskonSistem: 0,
  diskonDiberikan: 0,
  diskonSistemCurrency: 0,
  diskonDiberikanCurrency: 0,
  estimasiWaktu: null,
  totalHarga: null,
  ...INITIAL_SAVED_ROW,
  isSaved: false,
};

export const INITIAL_DATA_TABLE_PART_QR = {
  kodePart: null,
  namaPart: null,
  qtyPart: 1,
  qtyStock: 0,
  partQrCode: null,
  hargaSatuanSistem: 0,
  hargaDiberikan: 0,
  diskonSistem: 0,
  diskonDiberikan: 0,
  diskonSistemCurrency: 0,
  diskonDiberikanCurrency: 0,
  totalHarga: null,
  ...INITIAL_SAVED_ROW,
  isSaved: false
};

export const INITIAL_DATA_TABLE_PART_NON_QR = {
  kodePart: null,
  namaPart: null,
  qtyPart: 0,
  qtyStock: 0,
  hargaSatuanSistem: 0,
  hargaDiberikan: 0,
  diskonSistem: 0,
  diskonDiberikan: 0,
  diskonSistemCurrency: 0,
  diskonDiberikanCurrency: 0,
  totalHarga: 0,
  ...INITIAL_SAVED_ROW,
  isSaved: false
};
